import React from "react";
import "./Divider.scss";

export default function Divider() {
  return <div className="section-divider"></div>;
}
